import React, { useState, useEffect } from "react";
import "./CustomPagination.css";
import { Button, Input } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { pageNotExistValidationError, pageNumberValidationError } from "../../Utils/CommonErrors";
import { showErrorMessage } from "../../Utils/CommonMessage";

const CustomPagination = ({ pagination, onPageChange, groupSize = 3 }) => {
  const { current, pageSize, total } = pagination;

  const [currentPage, setCurrentPage] = useState(current || 1);
  const [currentPageSize, setCurrentPageSize] = useState(pageSize || 10);
  const [inputValue, setInputValue] = useState();
  const totalPages = pagination && Math.ceil(pagination?.total / pagination?.pageSize);
  const currentGroup = Math.floor((currentPage - 1) / groupSize);
  const startPage = currentGroup * groupSize + 1;
  const endPage = Math.min(startPage + groupSize - 1, totalPages);

  useEffect(() => {
    pagination && pagination?.current && setInputValue(current);
  }, [current]);

  useEffect(() => {
    setCurrentPage(current || 1);
  }, [current]);

  useEffect(() => {
    setCurrentPageSize(pageSize || 10);
  }, [pageSize]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    if (onPageChange) onPageChange(page, currentPageSize);
  };

  const handleNextGroup = () => {
    if (currentPage < totalPages) {
      handlePageClick(currentPage + 1);
    }
  };

  const handlePrevGroup = () => {
    if (currentPage > 1) {
      handlePageClick(currentPage - 1);
    }
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSubmit = () => {
    if (!inputValue || inputValue?.toString().trim() === "") {
      showErrorMessage(pageNumberValidationError);
    } else if (inputValue > totalPages || inputValue < 1) {
      const errMessage = pageNotExistValidationError(inputValue);
      showErrorMessage(errMessage);
    } else {
      onPageChange(parseInt(inputValue, 10), pageSize);
    }
  };

  return (
    <div className="custom-pagination-wrapper">
      <div className="custom-pagination-arrow-and-numbers-container">
        {/* Prev Button */}
        <Button className="custom-pagination-arrow" onClick={handlePrevGroup} disabled={currentPage === 1}>
          <LeftOutlined />
        </Button>

        {/* Page Numbers */}
        <div className="custom-pagination-pages">
          {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
            const page = startPage + i;
            return (
              <Button key={page} onClick={() => handlePageClick(page)} className={`custom-pagination-page ${currentPage === page ? "active" : ""}`}>
                {page}
              </Button>
            );
          })}
        </div>

        {/* Next Button */}
        <Button className="custom-pagination-arrow" onClick={handleNextGroup} disabled={currentPage === totalPages}>
          <RightOutlined />
        </Button>
      </div>

      {/* Page Input */}
      <div>
        <div className="custom-pagination-info">
          Page
          <div>
            <Input
              className="custom-pagination-info-input"
              type="number"
              value={inputValue}
              onPressEnter={handleSubmit}
              onChange={handleInputChange}
            />
          </div>
          of {Math.ceil(pagination?.total / pagination?.pageSize)}
        </div>
      </div>
    </div>
  );
};

export default CustomPagination;
